var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e4f8",
    d: "M3.995 4.497a4 4 0 0 1 4-4 4 4 0 0 1 4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e4f8",
    fillRule: "evenodd",
    d: "M4.01 4.504c0 2.996 2.6 5.337 3.9 8 1.368-2.664 4.1-5.004 4.1-8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#249fe6",
    d: "M7.994 1036.36c-2.48 0-4.5 2.02-4.5 4.5a.5.5 0 1 0 1 0c0-1.94 1.561-3.5 3.5-3.5 1.94 0 3.5 1.56 3.5 3.5a.5.5 0 1 0 1 0c0-2.48-2.02-4.5-4.5-4.5z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(0 -1036.362)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#249fe6",
    fillRule: "evenodd",
    d: "M4.004 1040.36a.5.5 0 0 0-.494.505c0 1.643.708 3.07 1.539 4.393.83 1.322 1.794 2.563 2.412 3.828a.5.5 0 0 0 .894.01c.65-1.264 1.662-2.506 2.536-3.828.873-1.322 1.619-2.75 1.619-4.4a.5.5 0 1 0-1 0c0 1.346-.619 2.586-1.453 3.849-.688 1.04-1.466 2.116-2.137 3.232-.637-1.112-1.371-2.185-2.024-3.222-.793-1.263-1.386-2.506-1.386-3.86a.5.5 0 0 0-.506-.506z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(0 -1036.362)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.995 4.5a1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1 1 1 0 0 1 1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#249fe6",
    d: "M7.994 1039.361c-.822 0-1.5.678-1.5 1.5 0 .823.678 1.5 1.5 1.5.823 0 1.5-.677 1.5-1.5 0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5zm4.09 5.227a.5.5 0 0 0-.18.967c.997.403 1.638.933 1.914 1.42.277.487.27.907-.091 1.425-.725 1.036-3.036 1.954-5.674 1.965-2.639.011-4.982-.883-5.748-1.922-.383-.52-.402-.943-.145-1.427.258-.485.875-1.019 1.856-1.43a.5.5 0 1 0-.387-.922c-1.12.47-1.937 1.102-2.352 1.883-.415.78-.343 1.723.223 2.49 1.132 1.535 3.711 2.34 6.559 2.328 2.847-.012 5.402-.837 6.488-2.39.543-.777.58-1.722.14-2.494-.438-.773-1.273-1.394-2.408-1.854a.5.5 0 0 0-.195-.039z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(0 -1036.362)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.56f2d4024f7e8f7288abdfa33a896461.svg";
export { ForwardRef as ReactComponent };